import { datadogRum } from '@datadog/browser-rum'
import { REACT_APP_BETA_ENVIRONMENT, REACT_APP_COMMIT_SHA, REACT_APP_ENV } from 'env'

const AUTOPILOT_SERVICE_KEY = 'blaze:isAutopilot'

export const getIsAutopilotFromStorage = (): boolean => {
  try {
    return localStorage.getItem(AUTOPILOT_SERVICE_KEY) === 'true'
  } catch {
    return false
  }
}

export const setIsAutopilotInStorage = (isAutopilot: boolean) => {
  try {
    localStorage.setItem(AUTOPILOT_SERVICE_KEY, String(isAutopilot))
  } catch {
    // localStorage may be unavailable in some contexts
  }
}

if (REACT_APP_ENV === 'production') {
  datadogRum.init({
    applicationId: '53c3f8f4-8955-445f-89db-ccae310e80f2',
    clientToken: 'pub5bf6a81599f9e6f4db7e89a8f040ec55',
    site: 'datadoghq.com',
    service: getIsAutopilotFromStorage() ? 'autopilot' : 'blaze',
    env: REACT_APP_BETA_ENVIRONMENT ? 'beta' : 'production',
    version: REACT_APP_COMMIT_SHA || undefined,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask-user-input',
  })
}

interface DatadogUser {
  id: number
  email: string
  isAutopilot: boolean
  plan: string | undefined
}

export const setDatadogUser = ({ id, email, isAutopilot, plan }: DatadogUser) => {
  datadogRum.setUser({
    id: String(id),
    email,
    isAutopilot,
    plan,
  })
}
